// extracted by mini-css-extract-plugin
export default {"cities":"region-cities_cities__pM8d-"};